<template>
    <div class="home">
        <!-- 顶部导航条 -->
        <div class="app-nav-wrap">
            <div class="app_nav_content">
                <div class="title">
                    <img src="../assets/logonew.png" />
<!--                    <img src="../assets/images/logo-gf.png" />-->
                </div>
                <!-- 顶部导航菜单 -->
                <ul class="nav_list" :default-active="$route.path">
                    <li class="nav_list_item" v-for="(menu,index) in menulist" :key="menu.name"
                        @click="goto(menu.url,index)" :class="{ active:index===isIndex}">
                        <div class="nav_icon">
                            <img :src="'http://uat.gfwlkj.cn/' + menu.icon" />
                        </div>
                        <p class="nav_text">{{menu.name}}</p>
                    </li>
                </ul>
            </div>
            <!--个人信心，修改密码，退出登录-->

            <div class="app_nav_content" style="margin-right: 45px;">
                <div style="margin-right: 45px;">
                    <div class="turn" v-if="msgNum!=0">
                        <router-link to="noticeMsgManage">
                            <el-badge :value="msgNum" class="item">
                                <img style="width:50px" src="../assets/message_dong.png" alt="">
                            </el-badge>
                        </router-link>
                    </div>
                    <router-link v-else to="noticeMsgManage">
                        <img style="width:50px" src="../assets/message_jing.png" alt="">
                    </router-link>

                </div>
                <el-dropdown>
                    <span class="el-dropdown-link">
                        <img v-if="loginMsg.photo" :src="'http://'+loginMsg.photo" alt="">
                        {{loginMsg.name}}
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown" class="getmsg">
                        <el-dropdown-item>
                            <div @click="resetForm('ruleForm')">修改密码</div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                            <div class="out_login" @click="outSystem">
                                <span>退出登录</span>
                            </div>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div class="app_content">
            <div class="el-menu-wrap" v-if="menuActive">
                <div style="height:3px;background:#eee;"></div>
                <div class="menu-title" @click="menuBtn" v-bind:class="{ active:isActive}">
                    <span class="menu-title-left">{{activetitle}}</span>
                    <i class="iconfont icon-xiajiantou menu-title-right"></i>
                </div>

                <!-- 左侧菜单列表 -->
                <el-menu :default-active="selection" :collapse="isCollapse" style="padding-top:10px;"
                    @select="handleSelect">
                    <el-menu-item :index="String(index)" v-for="(item,index) in submenulist" :key="index"
                        @click="routerInfo(item.url,index,item.functions)">
                        <i class="iconfont" :class="item.classStyle" style="font-size:24px;"></i>
                        <span slot="title" style="padding-left:20px;">{{item.name}}</span>
                    </el-menu-item>
                </el-menu>
            </div>
            <div class="app_wrap">
                <!-- 此处放置tab选项卡 el-tabs代码 -->
                <div class="template-tabs">
                    <el-tabs v-model="activeIndex" type="border-card" @tab-click="tabClick" v-if="options.length"
                        @tab-remove="tabRemove">
                        <el-tab-pane :key="index" v-for="(item, index) in options" :name="item.route"
                            :closable="item.name !== '工作台'" :label="item.name"></el-tab-pane>
                    </el-tabs>
                </div>
                <div class="content-wrap" ref="contentWrap">
                    <keep-alive :include="includeData">
                        <router-view />
                    </keep-alive>
                </div>
            </div>
        </div>
        <!--修改密码-->
        <div class="changepassword">
            <!--修改密码-->
            <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="480px">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
                    <el-form-item label="当前密码：" label-width="93px" prop="currentPassword">
                        <el-input v-model="ruleForm.currentPassword" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码：" label-width="93px" prop="newPassword">
                        <el-input v-model="ruleForm.newPassword" autocomplete="off"></el-input>
                    </el-form-item>
                    <div style="display: flex;justify-content: flex-start">
                        <el-form-item label="新密码：" label-width="93px" prop="confirmPassword">
                            <el-input v-model="ruleForm.confirmPassword" autocomplete="off"></el-input>
                        </el-form-item>
                        <div style="color: #F00400;margin-left: 10px;height: 40px;line-height: 40px">请再输入一次新密码</div>
                    </div>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="changePassword('ruleForm')">确 定</el-button>
                </div>
            </el-dialog>
        </div>
        <!-- <div>
      <router-view></router-view>
        </div>-->
    </div>
</template>

<script>
// import electron from "electron";
import store from "../store/index.js";
import VueCookies from "vue-cookies";
import { changePassword } from "@/api/index";
export default {
    neme: "home",
    data() {
        let loginMsg = JSON.parse(sessionStorage.getItem("loginMsg")) || {};
        let menulist = JSON.parse(localStorage.getItem("menu"));
        let validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入新密码"));
            } else {
                if (this.ruleForm.confirmPassword !== "") {
                    this.$refs.ruleForm.validateField("confirmPassword");
                }
                callback();
            }
        };
        let validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.ruleForm.newPassword) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            includeData: this.$store.state.includeData,
            loginMsg,
            msgNum: 0,
            selection: "0", //默认选中左侧菜单项
            isActive: false,
            menulist, //顶部菜单
            submenulist: [], //子菜单
            isIndex: null, //当前选中对的顶部选项
            menuActive: false, //是否显示左侧菜单
            isCollapse: false,
            activetitle: "",
            dialogFormVisible: false, //修改密码状态
            ruleForm: {
                currentPassword: "", //当前密码
                newPassword: "", //新密码
                confirmPassword: "", //确认密码
            }, //修改密码
            rules: {
                currentPassword: [
                    {
                        required: true,
                        message: "请输入当前密码",
                        trigger: "blur",
                    },
                    {
                        min: 6,
                        max: 12,
                        message: "长度在 6 到 12 个字符",
                        trigger: "blur",
                    },
                ],
                newPassword: [
                    { validator: validatePass, trigger: "blur" },
                    {
                        min: 6,
                        max: 12,
                        message: "长度在 6 到 12 个字符",
                        trigger: "blur",
                    },
                ],
                confirmPassword: [
                    { validator: validatePass2, trigger: "blur" },
                    {
                        min: 6,
                        max: 12,
                        message: "长度在 6 到 12 个字符",
                        trigger: "blur",
                    },
                ],
            },
        };
    },
    mounted() {
        if (this.$route.path !== "/index") {
            this.$store.commit("add_tabs", { route: "/index", name: "工作台" });
            this.$store.commit("add_tabs", {
                route: this.$route.path,
                name: this.$route.name,
            });
            this.$store.commit("set_active_index", this.$route.path);
        } else if (this.$route.path) {
            this.$store.commit("add_tabs", { route: "/index", name: "工作台" });
            this.$store.commit("set_active_index", "/index");
            this.$router.push("/index");
        }
        if (
            this.$route.path === "/home" &&
            this.$route.path.indexOf("userInfo") === -1
        ) {
            //   this.$store.commit('set_active_index', '/index')
            this.$router.push("/index");
        }
        this.msgNum = this.$store.state.msgNum;
    },
    methods: {
        handleScroll() {
            this.$nextTick(() => {
                let top = JSON.stringify(this.$refs.contentWrap.scrollTop);
                this.$store.state.top = top;
                // console.log(this.$store.state.top);
            });
        },
        //修改密码
        changePassword(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let params = Object.assign({}, this.ruleForm, {
                        id: this.loginMsg.employeeId,
                    });
                    this.$post(changePassword, params).then((res) => {
                        if (res.success === true) {
                            this.$message({
                                type: "success",
                                message: res.msg,
                            });
                            this.dialogFormVisible = false;
                        } else {
                            this.$message({
                                type: "error",
                                message: res.msg,
                            });
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.dialogFormVisible = true;
            this.ruleForm.currentPassword = "";
            this.ruleForm.newPassword = "";
            this.ruleForm.confirmPassword = "";
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields();
            }
        },
        handleSelect(key, keyPath) {
            //cosole.log(key, keyPath);
        },
        //左侧菜单切换，动态切换路由
        routerInfo(data, index, functions) {
            this.selection = index.toString();
            let houseidx = 0;
            let customidx = 0;
            this.options.map((item, index) => {
                // if (item.route == "/houseList") {
                //   houseidx = index;
                // }
                if (item.route == "/customerFind") {
                    customidx = index;
                }
            });
            if (data == "/sellHouse") {
                this.$store.commit("save_houseType", "SECONDHAND");
            } else if (data == "/renthouse") {
                this.$store.commit("save_houseType", "RENTING");
            }
            // if (data == "/houseList/1") {
            //   this.$router.push({ path: "/houseList" });
            //   this.$store.commit("save_houseType", "SECONDHAND");
            //   this.$store.state.options[houseidx].name = "二手房-房源列表";
            //   let arr = [];
            //   this.menulist.map(item => {
            //     if (item.childMenus) {
            //       item.childMenus.map(child => {
            //         if (child.url == "/houseList/1") {
            //           if (child.functions) {
            //             child.functions.map(fuc => {
            //               arr.push(fuc.functionName);
            //               if (fuc.regularPath) arr.push(fuc.regularPath);
            //             });
            //           }
            //         }
            //       });
            //     }
            //   });
            //   sessionStorage.setItem("permisList", JSON.stringify(arr));
            // } else if (data == "/houseList/2") {
            //   this.$router.push({ path: "/houseList" });
            //   this.$store.commit("save_houseType", "RENTING");
            //   this.$store.state.options[houseidx].name = "租房-房源列表";
            //   let arr = [];
            //   this.menulist.map(item => {
            //     if (item.childMenus) {
            //       item.childMenus.map(child => {
            //         if (child.url == "/houseList/2") {
            //           if (child.functions) {
            //             child.functions.map(fuc => {
            //               arr.push(fuc.functionName);
            //               if (fuc.regularPath) arr.push(fuc.regularPath);
            //             });
            //           }
            //         }
            //       });
            //     }
            //   });
            //   sessionStorage.setItem("permisList", JSON.stringify(arr));
            // }
            if (data == "/customerFind/1") {
                this.$router.push({ path: "/customerFind" });
                this.$store.commit("save_customerType", "WANT_TO_BUY");
                this.$store.state.options[customidx].name = "客源管理-求购";
                let arr = [];
                this.menulist.map((item) => {
                    if (item.childMenus) {
                        item.childMenus.map((child) => {
                            if (child.url == "/customerFind/1") {
                                if (child.functions) {
                                    child.functions.map((fuc) => {
                                        arr.push(fuc.functionName);
                                      if (fuc.regularPath) arr.push(fuc.regularPath);
                                    });
                                }
                            }
                        });
                    }
                });
                sessionStorage.setItem("permisList", JSON.stringify(arr));
            } else if (data == "/customerFind/2") {
                this.$router.push({ path: "/customerFind" });
                this.$store.commit("save_customerType", "WANT_TO_RENT");
                this.$store.state.options[customidx].name = "客源管理-求租";
                let arr = [];
                this.menulist.map((item) => {
                    if (item.childMenus) {
                        item.childMenus.map((child) => {
                            if (child.url == "/customerFind/2") {
                                if (child.functions) {
                                    child.functions.map((fuc) => {
                                        arr.push(fuc.functionName);
                                        if (fuc.regularPath) arr.push(fuc.regularPath);
                                    });
                                }
                            }
                        });
                    }
                });
                sessionStorage.setItem("permisList", JSON.stringify(arr));
            } else {
                this.$router.push({ path: data });
            }
            //  console.log("房元类型", this.$store.state.houseType)
        },
        //菜单隐藏
        menuBtn() {
            this.isActive = !this.isActive;
            this.isCollapse = !this.isCollapse;
        },
        //顶部菜单切换，动态的切换路由
        goto(data, index) {
            this.selection = "0";
            this.isIndex = index;
            if (this.isIndex !== null) {
                // 获取当前一级菜单的子菜单
                this.menuActive = true;
                this.submenulist = this.menulist[index].childMenus;
                this.activetitle = this.menulist[index].name;
                // 房源以及客源路由单独判断
                // if (this.submenulist[0].url == "/houseList/1") {
                //   this.$router.push({ path: "/houseList" });
                //   this.$store.commit("save_houseType", "SECONDHAND");
                //   let arr = [];
                //   this.menulist.map(item => {
                //     if (item.childMenus) {
                //       item.childMenus.map(child => {
                //         if (child.url == "/houseList/1") {
                //           if (child.functions) {
                //             child.functions.map(fuc => {
                //               arr.push(fuc.functionName);
                //               if (fuc.regularPath) arr.push(fuc.regularPath);
                //             });
                //           }
                //         }
                //       });
                //     }
                //   });
                //   sessionStorage.setItem("permisList", JSON.stringify(arr));
                // } else if (this.submenulist[0].url == "/houseList/2") {
                //   this.$router.push({ path: "/houseList" });
                //   this.$store.commit("save_houseType", "RENTING");
                //   let arr = [];
                //   this.menulist.map(item => {
                //     if (item.childMenus) {
                //       item.childMenus.map(child => {
                //         if (child.url == "/houseList/2") {
                //           if (child.functions) {
                //             child.functions.map(fuc => {
                //               arr.push(fuc.functionName);
                //               if (fuc.regularPath) arr.push(fuc.regularPath);
                //             });
                //           }
                //         }
                //       });
                //     }
                //   });
                //   sessionStorage.setItem("permisList", JSON.stringify(arr));
                // }
                if (this.submenulist[0].url == "/customerFind/1") {
                    this.$router.push({ path: "/customerFind" });
                    this.$store.commit("save_customerType", "WANT_TO_BUY");
                    let arr = [];
                    this.menulist.map((item) => {
                        if (item.childMenus) {
                            item.childMenus.map((child) => {
                                if (child.url == "/customerFind/1") {
                                    if (child.functions) {
                                        child.functions.map((fuc) => {
                                            arr.push(fuc.functionName);
                                          if (fuc.regularPath) arr.push(fuc.regularPath);
                                        });
                                    }
                                }
                            });
                        }
                    });
                    sessionStorage.setItem("permisList", JSON.stringify(arr));
                } else if (this.submenulist[0].url == "/customerFind/2") {
                    this.$router.push({ path: "/customerFind" });
                    this.$store.commit("save_customerType", "WANT_TO_RENT");
                    let arr = [];
                    this.menulist.map((item) => {
                        if (item.childMenus) {
                            item.childMenus.map((child) => {
                                if (child.url == "/customerFind/2") {
                                    if (child.functions) {
                                        child.functions.map((fuc) => {
                                            arr.push(fuc.functionName);
                                          if (fuc.regularPath) arr.push(fuc.regularPath);
                                        });
                                    }
                                }
                            });
                        }
                    });
                    sessionStorage.setItem("permisList", JSON.stringify(arr));
                } else {
                    this.$router.push({ path: this.submenulist[0].url });
                }
            }
        },
        // tab切换时，动态的切换路由
        tabClick(tab, event) {
            if (tab.label !=='客源详情'){
                this.selection = "0";
            }
            this.menuActive = true; //左侧菜单显示
            let path = this.activeIndex;

            this.$router.push({ path: path });
            let ment = [];
            this.menulist.map((item) => {
                ment.concat(item.childMenus);
            });
            ment.map((item, index) => {
                if (tab.label !== item.name) {
                    this.menuActive = false;
                    this.isIndex = null;
                }
            });
            if (tab.label == "工作台") {
                this.menuActive = false;
                this.isIndex = null;
            }
            // if (tab.label == "二手房-房源列表") {
            //   this.menuActive = true;

            //   this.$store.commit("save_houseType", "SECONDHAND");
            //   this.selection = "0";
            //   let arr = [];
            //   this.menulist.map((item, index) => {
            //     if (item.childMenus) {
            //       item.childMenus.map(child => {
            //         if (child.url == "/houseList/1") {
            //           this.isIndex = index; //顶部样式显示
            //           this.activetitle = this.menulist[index].name;
            //           this.submenulist = this.menulist[index].childMenus; //当前显示菜单
            //           if (child.functions) {
            //             child.functions.map(fuc => {
            //               arr.push(fuc.functionName);
            //               if (fuc.regularPath) arr.push(fuc.regularPath);
            //             });
            //           }
            //         }
            //       });
            //     }
            //   });
            //   sessionStorage.setItem("permisList", JSON.stringify(arr));
            // } else if (tab.label == "租房-房源列表") {
            //   this.menuActive = true;

            //   this.$store.commit("save_houseType", "RENTING");
            //   this.selection = "1";
            //   let arr = [];
            //   this.menulist.map((item, index) => {
            //     if (item.childMenus) {
            //       item.childMenus.map(child => {
            //         if (child.url == "/houseList/2") {
            //           this.isIndex = index; //顶部样式显示
            //           this.activetitle = this.menulist[index].name;
            //           this.submenulist = this.menulist[index].childMenus; //当前显示菜单
            //           if (child.functions) {
            //             child.functions.map(fuc => {
            //               arr.push(fuc.functionName);
            //               if (fuc.regularPath) arr.push(fuc.regularPath);
            //             });
            //           }
            //         }
            //       });
            //     }
            //   });
            //   sessionStorage.setItem("permisList", JSON.stringify(arr));
            // }
            if (tab.label == "客源管理-求购") {
                this.menuActive = true;

                this.$store.commit("save_customerType", "WANT_TO_BUY");
                this.selection = "0";
                let arr = [];
                this.menulist.map((item, index) => {
                    if (item.childMenus) {
                        item.childMenus.map((child) => {
                            if (child.url == "/customerFind/1") {
                                this.isIndex = index; //顶部样式显示
                                this.activetitle = this.menulist[index].name;
                                this.submenulist = this.menulist[
                                    index
                                ].childMenus; //当前显示菜单
                                if (child.functions) {
                                    child.functions.map((fuc) => {
                                        arr.push(fuc.functionName);
                                        if (fuc.regularPath) arr.push(fuc.regularPath);
                                    });
                                }
                            }
                        });
                    }
                });
                sessionStorage.setItem("permisList", JSON.stringify(arr));
            } else if (tab.label == "客源管理-求租") {
                this.menuActive = true;

                this.$store.commit("save_customerType", "WANT_TO_RENT");
                this.selection = "1";
                let arr = [];
                this.menulist.map((item, index) => {
                    if (item.childMenus) {
                        item.childMenus.map((child) => {
                            if (child.url == "/customerFind/2") {
                                this.isIndex = index; //顶部样式显示
                                this.activetitle = this.menulist[index].name;
                                if (child.functions) {
                                    this.submenulist = this.menulist[
                                        index
                                    ].childMenus; //当前显示菜单
                                    child.functions.map((fuc) => {
                                        arr.push(fuc.functionName);
                                        if (fuc.regularPath) arr.push(fuc.regularPath);
                                    });
                                }
                            }
                        });
                    }
                });
                sessionStorage.setItem("permisList", JSON.stringify(arr));
            } else {
                this.menulist.map((menu, index) => {
                    menu.childMenus.map((menuchild, idx) => {
                        if (tab.label == menuchild.name) {
                            this.submenulist = menu.childMenus;
                            this.activetitle = menu.name;
                            this.menuActive = true;
                            this.isIndex = index;
                            menuchild.functions.map((item) => {
                                let obj = {};
                                obj.name = item.functionName;
                                obj.level = item.level;
                            });
                            this.selection = idx.toString();
                            // console.log("左侧菜单", idx)
                        }
                    });
                });
            }
        },
        //删除Tab，动态的切换路由
        tabRemove(targetName) {
            /* 去除name报错 */
            // let path = targetName.replace(/\//g,"");
            this.$store.commit("delete_clude", targetName);
            // 首页不可删除
            if (targetName === "/index") {
                return;
            }
            this.$store.commit("delete_tabs", targetName);
            if (this.activeIndex === targetName) {
                // 设置当前激活的路由
                if (this.options && this.options.length >= 1) {
                    this.$store.commit(
                        "set_active_index",
                        this.options[this.options.length - 1].route
                    );
                    this.$router.push({ path: this.activeIndex });
                    let ment = this.menulist[0].childMenus.concat(
                        this.menulist[1].childMenus,
                        this.menulist[2].childMenus
                    );
                    ment.map((item, index) => {
                        if (this.activeIndex !== item.url) {
                            this.menuActive = false;
                            this.isIndex = null;
                        }
                    });
                    // if (this.activeIndex == "/houseList") {
                    //   if (this.$store.state.houseType == "SECONDHAND") {
                    //     this.selection = "0";
                    //     this.$store.commit("save_houseType", "SECONDHAND");
                    //     this.menuActive = true;
                    //     this.menulist.map((ite, idx) => {
                    //       if (this.activeIndex == ite.url) {
                    //         this.menuActive = true;
                    //         this.activetitle = this.menulist[idx].name;
                    //         this.submenulist = this.menulist[idx].childMenus; //当前显示菜单
                    //         // this.selection = String(idx);
                    //         this.isIndex = idx;
                    //       }
                    //     });
                    //   } else {
                    //     this.selection = "1";
                    //     this.$store.commit("save_houseType", "RENTING");
                    //     this.menuActive = true;
                    //     this.menulist.map((ite, idx) => {
                    //       if (this.activeIndex == ite.url) {
                    //         this.menuActive = true;
                    //         this.activetitle = this.menulist[idx].name;
                    //         this.submenulist = this.menulist[idx].childMenus; //当前显示菜单
                    //         // this.selection = String(idx);
                    //         this.isIndex = idx;
                    //       }
                    //     });
                    //   }
                    // }
                    if (this.activeIndex == "/customerFind") {
                        // debugger
                        if (this.$store.state.customerType == "WANT_TO_BUY") {
                            this.selection = "0";
                            this.$store.commit(
                                "save_customerType",
                                "WANT_TO_BUY"
                            );
                            this.menuActive = true;
                            this.menulist.map((ite, idx) => {
                                if (this.activeIndex == ite.url) {
                                    this.menuActive = true;
                                    this.activetitle = this.menulist[idx].name;
                                    this.submenulist = this.menulist[
                                        idx
                                    ].childMenus; //当前显示菜单
                                    // this.selection = String(idx);
                                    this.isIndex = idx;
                                }
                            });
                        } else {
                            this.selection = "1";
                            this.$store.commit(
                                "save_customerType",
                                "WANT_TO_RENT"
                            );
                            this.menuActive = true;
                            this.menulist.map((ite, idx) => {
                                if (this.activeIndex == ite.url) {
                                    this.menuActive = true;
                                    this.activetitle = this.menulist[idx].name;
                                    this.submenulist = this.menulist[
                                        idx
                                    ].childMenus; //当前显示菜单
                                    // this.selection = String(idx);
                                    this.isIndex = idx;
                                }
                            });
                        }
                    } else {
                        this.menulist.map((ite, idx) => {
                            ite.childMenus.map((item, index) => {
                                if (this.activeIndex == item.url) {
                                    this.menuActive = true;
                                    this.activetitle = this.menulist[idx].name;
                                    this.submenulist = this.menulist[
                                        idx
                                    ].childMenus; //当前显示菜单
                                    this.selection = String(index);
                                    this.isIndex = idx;
                                }
                            });
                        });
                    }
                } else {
                    this.$router.push({ path: "/" });
                }
            }
        },
        // 退出登录
        outSystem() {
            localStorage.removeItem("customerId");
            VueCookies.remove("accessToken");
            this.$router.push({ path: "/" });
            // electron.ipcRenderer.send("loginOut");
            this.$nextTick(() => {
              location.reload()
            })
        },
    },

    computed: {
        options() {
            return this.$store.state.options;
        },
        activeIndex: {
            get() {
                return this.$store.state.activeIndex;
            },
            set(val) {
                this.$store.commit("set_active_index", val);
            },
        },
    },
    watch: {
        "$store.state.msgNum": function () {
            this.msgNum = this.$store.state.msgNum;
        },

        options(val) {
            if (val.length == 1) {
                this.menuActive = false;
                this.isIndex = null;
            }
        },
        $route(to) {
            let flag = false;
            // console.log(123123, to.path)
            if (to.path === "/CommunityDetail") {
                // console.log('楼盘详情')
                window.addEventListener("scroll", this.handleScroll, true); // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
            } else {
                window.removeEventListener("scroll", this.handleScroll, true); // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
            }
            this.options.map((option, index) => {
                if (option.route === to.path) {
                    flag = true;
                    // if (to.path.split("/")[1] == "houseList") {
                    //   this.$store.commit("set_active_index", "/" + to.path.split("/")[1]);
                    //   if (to.query.statuse) {
                    //     if (to.query.statuse != "URGENTRENT") {
                    //       this.$store.state.options[index].name = "二手房-房源列表";
                    //       this.isIndex = 1;
                    //       let arr = [];
                    //       this.menulist.map(item => {
                    //         if (item.childMenus) {
                    //           item.childMenus.map(child => {
                    //             if (child.url == "/houseList/1") {
                    //               if (child.functions) {
                    //                 child.functions.map(fuc => {
                    //                   arr.push(fuc.functionName);
                    //                   if (fuc.regularPath) arr.push(fuc.regularPath);
                    //                 });
                    //               }
                    //             }
                    //           });
                    //         }
                    //       });
                    //       sessionStorage.setItem("permisList", JSON.stringify(arr));
                    //     } else {
                    //       this.$store.state.options[index].name = "租房-房源列表";
                    //       this.isIndex = 1;
                    //       let arr = [];
                    //       this.menulist.map(item => {
                    //         if (item.childMenus) {
                    //           item.childMenus.map(child => {
                    //             if (child.url == "/houseList/2") {
                    //               if (child.functions) {
                    //                 child.functions.map(fuc => {
                    //                   arr.push(fuc.functionName);
                    //                   if (fuc.regularPath) arr.push(fuc.regularPath);
                    //                 });
                    //               }
                    //             }
                    //           });
                    //         }
                    //       });
                    //       sessionStorage.setItem("permisList", JSON.stringify(arr));
                    //     }
                    //   } else {
                    //     if (this.$store.state.houseType == "SECONDHAND") {
                    //       this.$store.state.options[index].name = "二手房-房源列表";
                    //     } else {
                    //       this.$store.state.options[index].name = "租房-房源列表";
                    //     }
                    //   }
                    // }
                    if (to.path.split("/")[1] == "customerFind") {
                        this.$store.commit(
                            "set_active_index",
                            "/" + to.path.split("/")[1]
                        );
                        if (this.$store.state.customerType == "WANT_TO_BUY") {
                            this.$store.state.options[index].name =
                                "客源管理-求购";
                        } else {
                            this.$store.state.options[index].name =
                                "客源管理-求租";
                        }
                    } else {
                        this.$store.commit(
                            "set_active_index",
                            "/" + to.path.split("/")[1]
                        );
                    }
                }
            });
            if (!flag) {
                this.$store.commit(
                    "set_active_index",
                    "/" + to.path.split("/")[1]
                );
                // if (to.path.split("/")[1] == "houseList") {
                //   if (to.query.statuse) {
                //     if (to.query.statuse != "URGENTRENT") {
                //       this.$store.commit("add_tabs", {
                //         route: "/" + to.path.split("/")[1],
                //         name: "二手房-房源列表"
                //       });
                //       this.isIndex = 1;
                //       let arr = [];
                //       this.menulist.map(item => {
                //         if (item.childMenus) {
                //           item.childMenus.map(child => {
                //             if (child.url == "/houseList/1") {
                //               if (child.functions) {
                //                 child.functions.map(fuc => {
                //                   arr.push(fuc.functionName);
                //                   if (fuc.regularPath) arr.push(fuc.regularPath);
                //                 });
                //               }
                //             }
                //           });
                //         }
                //       });
                //       sessionStorage.setItem("permisList", JSON.stringify(arr));
                //     } else {
                //       this.$store.commit("add_tabs", {
                //         route: "/" + to.path.split("/")[1],
                //         name: "租房-房源列表"
                //       });
                //       this.isIndex = 1;
                //       let arr = [];
                //       this.menulist.map(item => {
                //         if (item.childMenus) {
                //           item.childMenus.map(child => {
                //             if (child.url == "/houseList/2") {
                //               if (child.functions) {
                //                 child.functions.map(fuc => {
                //                   arr.push(fuc.functionName);
                //                 });
                //               }
                //             }
                //           });
                //         }
                //       });
                //       sessionStorage.setItem("permisList", JSON.stringify(arr));
                //     }
                //   } else {
                //     if (
                //       this.$store.state.houseType == "SECONDHAND" ||
                //       !this.$store.houseType
                //     ) {
                //       this.$store.commit("add_tabs", {
                //         route: "/" + to.path.split("/")[1],
                //         name: "二手房-房源列表"
                //       });
                //     } else {
                //       this.$store.commit("add_tabs", {
                //         route: "/" + to.path.split("/")[1],
                //         name: "租房-房源列表"
                //       });
                //     }
                //   }
                // }
                if (to.path.split("/")[1] == "customerFind") {
                    if (
                        this.$store.state.customerType == "WANT_TO_BUY" ||
                        !this.$store.customerType
                    ) {
                        this.$store.commit("add_tabs", {
                            route: "/" + to.path.split("/")[1],
                            name: "客源管理-求购",
                        });
                    } else {
                        this.$store.commit("add_tabs", {
                            route: "/" + to.path.split("/")[1],
                            name: "客源管理-求租",
                        });
                    }
                } else {
                    this.$store.commit("add_tabs", {
                        route: "/" + to.path.split("/")[1],
                        name: to.name,
                    });
                }
                /* 去除name报错 */
                // let path = to.path.replace(/\//g,"");
                this.$store.commit("add_clude", to.path);
            }
        },
    },
};
</script>
<style lang="less" scoped>
&.active {
    width: 65px !important;
    .menu-title-left {
        display: none;
    }
    > .menu-title-right {
        margin-right: 15px !important;
        transform: rotate(-90deg) !important;
    }
}
</style>
<style lang="less">
.getmsg {
    width: 100px !important;
    height: auto !important;
    margin-top: 10px !important;
    .el-dropdown-menu__item {
        color: #333333 !important;
        float: none !important;
        /*width: 100% !important;*/
        padding-top: 0 !important;
        margin-top: 0 !important;
        line-height: 2 !important;
    }
}

.el-tooltip__popper.is-dark {
    // left: 60px !important;
    background: rgba(236, 245, 255);
    color: #5e75e6;
    div {
        span {
            padding-left: 0px !important;
        }
    }
}
.el-tooltip__popper[x-placement^="right"] .popper__arrow {
    border-right-color: rgba(236, 245, 255);
}
.el-tooltip__popper[x-placement^="right"] .popper__arrow:after {
    border-right-color: rgba(236, 245, 255);
}
.home {
    min-width: 1440px;
    height: 100vh;
    background: #f5f5f5;
    display: flex;
    flex-direction: column;
    .app-nav-wrap {
        height: 88px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        //padding-left: 40px;
      padding-left: 20px;
        background: white;
        .app_nav_content {
            display: flex;
            align-items: center;
            position: relative;
            .turn {
                animation: turn 1.5s linear infinite;
                .el-badge__content.is-fixed {
                    right: 22px;
                    top: 8px;
                }
            }
            @keyframes turn {
                0% {
                    -webkit-transform: rotate(0deg);
                }
                25% {
                    -webkit-transform: rotate(20deg);
                }
                50% {
                    -webkit-transform: rotate(0deg);
                }
                75% {
                    -webkit-transform: rotate(-20deg);
                }
                100% {
                    -webkit-transform: rotate(0deg);
                }
            }
            .nav_list {
                display: flex;
                height: 84px;
                margin-left: 20px;
                min-width: 900px;
                margin-top: -2px;

                .nav_list_item {
                    text-align: center;
                    cursor: pointer;
                    &.active {
                        background: #f5f5f5;
                        border-bottom: 4px solid #5e75e6;
                    }
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    height: 100%;
                    position: relative;
                    padding: 0 15px;

                    // margin-left: 20px;
                    .nav_icon {
                        width: 46px;
                        height: 46px;
                        border-radius: 100%;
                        /*border: 1px solid red;*/
                        img {
                            width: 46px;
                            height: 46px;
                        }
                    }

                    .nav_text {
                        font-size: 14px;
                        margin-top: 5px;
                    }

                    .nav_select {
                        position: absolute;
                        top: 80px;
                        left: -50;
                        z-index: 999999;
                        background: white;
                        width: 180px;
                        font-size: 16px;
                        color: #333333;
                        box-shadow: 0 3px 6px #ccc;
                        text-align: center;
                        padding: 10px 0;
                        display: none;

                        &.active {
                            display: block;
                        }

                        > li {
                            line-height: 30px;
                            cursor: pointer;
                        }

                        > li:hover {
                            color: #5e75e6;
                        }
                    }
                }
            }
        }
        .out_login {
            min-width: 60px;
            // height: 80px;
            display: flex;
            flex-direction: column;
            margin-right: 80px;
            cursor: pointer;
            .out_icon {
                width: 30px;
                height: 30px;
                border-radius: 100%;
                background: #f5f5f5;
                margin: 0 auto;
            }
            > span {
                margin-top: 10px;
                font-size: 14px;
            }
        }
        .el-dropdown-link {
            cursor: pointer;
            img {
                width: 45px;
                height: 45px;
                border-radius: 50%;
                vertical-align: middle;
                margin-right: 8px;
                font-size: 0;
            }
        }
        .el-icon-arrow-down {
            font-size: 14px;
        }
        .el-dropdown {
            min-width: 146px;
            /*margin-right: 45px;*/
            font-size: 16px;
        }
    }
    .app_content {
        flex: 1;
        display: flex;
        flex-flow: row;
        overflow: hidden;
        .el-menu-wrap {
            // width: 150px;
            .iconfont {
                font-size: 25px;
            }
            background: #fff;
            .el-menu-item {
                height: 40px;
                line-height: 40px;
            }
            .el-menu-item.is-active {
                color: #5e75e6;
                background: #f5f5f5;
                padding-left: 6px;
                border-left: 6px solid #5e75e6;
            }
            .menu-title {
                width: 169px;
                height: 41px;
                line-height: 41px;
                background: #5e75e6;
                color: #fff;
                font-size: 14px;
                position: relative;
                .menu-title-left {
                    font-size: 14px;
                    line-height: 41px;
                    margin-left: 30px;
                }
                .menu-title-right {
                    position: absolute;
                    margin: 0px;
                    right: 10px;
                    color: #fff;
                    font-size: 14px;
                    transform: rotate(90deg);
                }
            }

            .menu-title.is-active {
                margin: 0;
                color: #fff;
                background: #5e75e6;
                border: none;
            }
        }
        .app_wrap {
            flex: 1;
            padding: 3px 0px 0 0px;
            width: 100%;
            overflow: auto;
            display: flex;
            flex-direction: column;
            .template-tabs {
                border-bottom: 2px solid #5e75e6;
                /*margin-top: 10px;*/
                height: 41px;
                > .el-tabs {
                    > .el-tabs__header {
                        background-color: white;
                        > .el-tabs__nav-wrap {
                            > .el-tabs__nav-scroll {
                                > .el-tabs__nav {
                                    display: flex;
                                    > .el-tabs__item {
                                        &.is-active {
                                            background-color: none;
                                            background-color: #5e75e6;
                                            border-top: 1px solid #5e75e6;
                                            color: white;
                                            .house_Type_wrap {
                                                .el-tabs {
                                                    .el-tabs__header {
                                                        .el-tabs__nav-wrap {
                                                            .el-tabs__nav-scroll {
                                                                .el-tabs__nav {
                                                                    .el-tabs__item {
                                                                        color: #ccc;
                                                                        border: none;
                                                                        &.is-active {
                                                                            background: #f5f5f5;
                                                                            color: white;
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                // .house_type_item {
                                                //   padding: 0 6px;
                                                //   color: #bbb;
                                                // }
                                            }
                                        }
                                        display: flex;
                                        align-items: center;
                                        .house_Type_wrap {
                                            .el-tabs {
                                                &.el-tabs--border-card {
                                                    background-color: none;
                                                    background: rgba(
                                                        255,
                                                        255,
                                                        255,
                                                        0
                                                    );
                                                }
                                                .el-tabs__header {
                                                    background-color: none;
                                                    background: rgba(
                                                        255,
                                                        255,
                                                        255,
                                                        0
                                                    );
                                                    .el-tabs__nav-wrap {
                                                        .el-tabs__nav-scroll {
                                                            .el-tabs__nav {
                                                                .el-tabs__item {
                                                                    color: #ccc;
                                                                    border: none;
                                                                    &.is-active {
                                                                        background: #f5f5f5;
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            // .house_type_item {
                                            //   padding: 0 6px;
                                            //   color: #bbb;
                                            // }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .content-wrap {
                flex: 1;
                // overflow: auto;
                // min-width: 1770px;
                // overflow: hidden;
                overflow-y: scroll;
                overflow-x: scroll;
                /*background: #ffffff;*/
                // border-top: none;
                // padding: 0;
            }
            .el-tabs--border-card > .el-tabs__content {
                padding: 0;
            }

            .el-tabs--border-card {
                height: 39px;
                border: none;
                box-shadow: none;
                background-color: #f5f5f5;
            }
            // .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
            //   background-color: none;
            //   background-color: #5e75e6;
            //   color: white;
            // }
        }
    }
    .changepassword {
        .el-dialog {
            .el-dialog__header {
                .el-dialog__title {
                    color: #5e75e6;
                    font-size: 20px;
                }
            }
            .el-dialog__body {
                padding: 15px 25px !important;
                .el-input {
                    .el-input__inner {
                        height: 30px;
                        line-height: 30px;
                    }
                }
                .el-form-item__label {
                    padding: 0;
                }
            }
            .el-button--primary {
                background: #5e75e6;
                border-color: #5e75e6;
            }
        }
    }
}
</style>
